<template>
  <div class="logCon pr" ref="bodyCon1">
    <template v-if="type !='100000'">
      <div class="searchCons tal" ref="searchCon">
      <template v-for="(item, index) in search" :key="">
        <template v-if="item.type == 'select'">
          <template v-if="index == 0"><Select style="width:120px;margin-right: 10px;" v-model="actionType">
              <Option value="0">执行动作</Option>
              <Option v-for="(option, index) in item.option" :value="option.value" :key="index">{{ option.label }}
              </Option>
            </Select>
          </template>
          <template v-else>
            <Select style="width:120px;margin-right: 10px;" v-model="logType">
              <Option value="0">操作类型</Option>
              <Option v-for="(option, index) in item.option" :value="option.value" :key="index">{{ option.label }}
              </Option>
            </Select>
          </template>
        </template>
      </template>
      <!-- <Input style="width:200px;margin-left:10px;" v-for="(item, key) in $logBasic.getSearch(this.type).serchTxt"
        :placeholder="item.placeholder" :key="key" /> -->
      <span style="margin: 0 4px 0 10px;">进程:</span>
      <Select style="width:500px;" v-model="process" multiple filterable :remote-method="remoteMethod"
        @on-change="changeFelect" :max-tag-count="3" placeholder="支持模糊搜索进程ID、进程名、进程路径及各类进程特征信息" :loading="loading">
        <Option v-for="(option, index) in processSelect" :value="option.value" :key="index">{{ option.label }}</Option>
      </Select>
      <!-- <span style="margin-left:10px;">{{ titles.splice(0, 2) }}</span> -->
      <span style="margin:0 4px 0 20px;" v-if="titles != '' && placeHolder != ''">模块:</span>
      <Select style="width:120px;" v-model="searchType"  v-if="titles != '' && placeHolder != ''">
        <!-- <Option value="0">全部</Option> -->
        <Option v-for="(option,index) in searchList" :key="index" :value="option.value">{{option.label}}</Option>
      </Select>
      <Input style="width:340px;" v-model="info" :placeholder="placeHolder" clearable v-if="placeHolder != ''"
        @on-change="changeFelect" />
      <div class="fr"><Button type="primary" style="margin-right:10px;" @click="getLogList">搜索</Button><Button
          type="primary" @click="refreshFn">刷新</Button>
      </div>
      </div>
      <Table class="tableCon" :height="height"  ref="table" row-key="id" :columns="columns" :data="data" border
      :loading="loadingTable">
      </Table>
    </template>
    <template v-else>
      <Table  class="tableCon" :height="height"  ref="table" row-key="id" :columns="channelColumns" :data="channelData" border :loading="loadingTable">
        <template slot-scope="{row,index}" slot="pkgType">
          <Tag  color="blue" v-if="row.pkgType == 1">本地文件</Tag>
          <Tag  color="green"  v-else-if="row.pkgType == 2">云端文件</Tag>
          <Tag  color="red" v-else>脚本</Tag>
        </template>
        <template slot-scope="{row,index}" slot="runFlag">
          <Tag v-if="row.runFlag ==0" color="blue">运行成功</Tag>
          <Tag  color="blue" v-else-if="row.runFlag ==1">不运行</Tag>
          <Tag v-else-if="row.runFlag ==2" color="red" >找不到对应的文件</Tag>
          <Tag v-else-if="row.runFlag ==3" color="red" >DLL加载失败</Tag>
          <Tag v-else-if="row.runFlag ==4" color="red" >未知文件类型</Tag>
          <Tag v-else color="red" >没有对应的包信息</Tag>
        </template>
      </Table>
    </template>
    <Page class="pageCon pa" @on-change="pagechange" @on-page-size-change="pageSizeChange" :total="total"
      :page-size="size" :current="page" :page-size-opts="[100, 500, 1000, 3000]" show-total show-sizer></Page>
  </div>
</template>
<script>
import { dragTable } from '../../../../utils/dragtable'
import { getLogTitle, getLogList, getProcess } from '../../../../requests/debug'
import { Base64 } from 'js-base64'
import select from '../../../../components/selctBox/select.vue'

import {exeRunLog} from '@/requests/task'
export default {
  components: { select },
  props: ['type', 'splitVal', 'search', 'id', 'placeHolder', 'titles'],
  data () {
    return {
      searchList: [],
      action: '',
      operation: '',
      data: [
      ],
      columns: [],
      channelColumns: [
        {
          title: '任务ID',
          key: 'cfgId',
          width: 70,
        },
        {
          title: '任务名称',
          key: 'title',
          align: 'center',
          tooltip: true,
          ellipsis: true,

        },
        {
          title: '任务类型',
          slot: 'pkgType',
          align: 'center',
          tooltip: true,
          ellipsis: true,
        },
        {
          title: '执行文件',
          key: 'fileFullPath',
          align: 'center',
          tooltip: true,
          ellipsis: true,
        },
        {
          title: '执行时间',
          key: 'createTime',
          align: 'center'
        },
        {
          title: '执行结果',
          slot: 'runFlag',
          align: 'center'

        },
      ],
      channelData: [],
      height: 300,
      total: 100,
      size: 100,
      page: 1,
      isLoad: false,
      actionType: '0',
      logType: '0',
      info: '',
      process: [],
      loading: false,
      processList: [
        // {
        //   value: 10001,
        //   label: 'test1'
        // },
        // {
        //   value: 10002,
        //   label: 'test2'
        // }
        {
          value: 'beijing',
          label: '北京'
        },
        {
          value: 'shanghai',
          label: '上海'
        },
        {
          value: 'shenzhen',
          label: '深圳'
        },
        {
          value: 'hangzhou',
          label: '杭州'
        },
        {
          value: 'guangzhou',
          label: '广州'
        }
      ],
      defaultVal: [],
      processSelect: [],
      loadingTable: false,
      searchType: '0',
      width: '100%'
    }
  },
  watch: {
    'searchType'() {
      console.log(this.searchType)
      if (this.searchType == 0) {
        this.info = ''
      }
    },
    '$store.state.log.refreshFn' () {
      if (this.type == 100000) {
        this.exeRunLog()
      } else {
        this.getLogList()
      }
    },
    '$store.state.log.selectPro' () {
      // this.process = []
      // // this.processSelect = []
      // console.log(this.$store.state.log.selectPro)
      // let json = ''
      // this.$store.state.log.selectPro.forEach(el => {
      //   console.log(el)
      //   console.log(el.fullPath)
      //   if (el.fullPath.indexOf("\\") != -1)
      //   {
      //     let arr = el.fullPath.split('\\')
      //     json = {
      //       value: el.pid,
      //       label: el.pid + '-' + arr[arr.length - 1]
      //     }

      //   } else
      //   {
      //     json = {
      //       value: el.pid,
      //       label: el.pid + '-'
      //     }
      //   }
      //   let index = this.processSelect.findIndex(val => val.value == el.pid)
      //   let index2 = this.process.findIndex(val => val == el.pid)
      //   if (index == -1)
      //   {
      //     this.processSelect.push(json)
      //   }
      //   if (index2 == -1)
      //   {
      //     this.process.push(el.pid)
      //   }
      // })
      // this.getLogList()
      this.setFn()
    },
    // processSelect () {
    //   this.getLogList()
    // },
    type () {
      this.isLoad = false
      this.getLogTitle()
      this.setFn()
    },
    splitVal () {
      this.setHeight()
    }
  },
  mounted () {
    this.setHeight()
    this.getLogTitle()
    this.setFn()
  },
  methods: {
    async exeRunLog() {
      let res = await exeRunLog({
        pageNo: this.page,
        id: this.id.id,
        pageSize: this.size,
      })
      if (res.code == 200) {
        this.channelData = res.data.records
        this.total = Number(res.data.total)
      }
    },
    setFn () {
      let json = ''
      this.process = []

      // // this.processSelect = []
      this.$store.state.log.selectPro.forEach(el => {
        if (el.fullPath.indexOf('\\') != -1) {
          let arr = el.fullPath.split('\\')
          json = {
            value: el.xid,
            label: el.pid + '-' + arr[arr.length - 1]
          }
        } else {
          json = {
            value: el.xid,
            label: el.pid + '-'
          }
        }
        let index = this.processSelect.findIndex(val => val.value == el.xid)
        let index2 = this.process.findIndex(val => val == el.xid)
        if (index == -1) {
          this.processSelect.push(json)
        }
        if (index2 == -1) {
          this.process.push(el.xid)
        }
      })
      if (this.type == 100000) {
        this.exeRunLog()
      } else {
        this.getLogList()
      }
    },
    refreshFn () {
      if (this.type == 100000) {
        this.exeRunLog()
      } else {
        this.getLogList()
      }
      this.$store.dispatch(
        'log/actionSetRefreshFn2'
      )
    },
    changeFelect (val) {
      if (val != '' && val.length) {
        val.forEach(el => {
          let index = this.$store.state.log.selectPro.findIndex((val) => val.xid == el)
          if (index == -1) {
            let key = this.processSelect.findIndex(val => val.value == el)
            if (key != -1) {
              let json = {
                xid: el,
                fullPath: el + '-' + this.processSelect[key].label
              }
              this.$store.dispatch(
                'log/actionAddSelectPro',
                json
              )
            }
          }
        })
      } else {
        this.$store.dispatch(
          'log/actionResetSelectPro',
          ''
        )
      }
    },
    async getProcess (info) {
      this.processSelect = []
      this.loading = true
      let res = await getProcess({
        hash: this.id.hash,
        barId: this.id.barId,
        osStartTime: this.id.osStartTime,
        info: info
      })
      this.loading = false
      if (res.code == 200) {
        res.data.forEach(el => {
          let json = {
            label: el.pid + '-' + el.exeName,
            value: el.xid
          }
          let index = this.processSelect.findIndex(val => val.value == el.xid)
          if (index == -1) {
            this.processSelect.push(json)
          }
        })
      }
    },
    async getLogList () {
      this.loadingTable = true
      let val = ''; let actionType = ''; let logType = ''
      if (this.actionType == '0') {
        actionType = ''
      } else {
        actionType = this.actionType
      }
      if (this.logType == '0') {
        logType = ''
      } else {
        logType = this.logType
      }

      let json = {
        actionKey: actionType,
        operateKey: logType,
        process: this.process,
        type: this.type
      }
      if (this.searchType != 0) {
        json[this.searchType] = this.info
      }
      val = JSON.stringify(json)
      let res = await getLogList({
        num: this.page,
        id: this.id.id,
        osStartTime: this.id.osStartTime,
        size: this.size,
        key: encodeURIComponent(val)
      })
      this.loadingTable = false
      if (res.code == 200) {
        // if (this.type == 6) {
        //   res.data.records.forEach(el => {
        //     el.url = Base64.decode(el.url)
        //   })
        // } else if (this.type == 2) {
        //   res.data.records.forEach(el => {
        //     el.driverFileDescription = Base64.decode(el.driverFileDescription)
        //   })
        // }
        // res.data.records.forEach(el => {
        //   if (el.url != '' && el.url != undefined) {
        //     el.url = Base64.decode(el.url)
        //   }
        //   if (el.driverFileDescription != '' && el.driverFileDescription != undefined) {
        //     el.driverFileDescription = Base64.decode(el.driverFileDescription)
        //   }
        //   if (el.moduleFileDescription != '' && el.moduleFileDescription != undefined) {
        //     el.moduleFileDescription = Base64.decode(el.moduleFileDescription)
        //   }
        //   if (el.fileDescription != '' && el.fileDescription != undefined) {
        //     el.fileDescription = Base64.decode(el.fileDescription)
        //   }
        // })
        this.data = res.data.records
        this.total = Number(res.data.total)
      }
    },
    async remoteMethod (query) {
      if (query != '') {
        this.getProcess(query)
      } else {
        this.processList = []
      }
    },
    setDefaultOptions (val) {
      this.processList = val
    },
    async getLogTitle () {
      if (this.isLoad) return
      this.columns = []
      this.searchList = []
      this.isLoad = true
      let res = await getLogTitle({
        type: this.type
      })
      let wid
      if (this.$refs.bodyCon1 != undefined && this.$refs.bodyCon1 != '' && this.$refs.bodyCon1.clientHeight != undefined) {
        wid = this.$refs.bodyCon1.clientWidth
      }
      if (res.code == 200) {
        let num = 0
        res.data.forEach(el => {
          if (el.attr.indexOf('Path') != -1) {
            num += 1
          }
        })
        res.data.forEach((element, index) => {
          let json = ''
          let json2 = {
            value: element.attr,
            label: element.label
          }
          if (index == res.data.length - 1) {
            json = {
              title: element.label,
              key: element.attr,
              tooltip: true,
              ellipsis: true,
            }
          } else {
            if (element.attr.indexOf('Path') != -1) {
              json = {
                title: element.label,
                key: element.attr,
                tooltip: true,
                ellipsis: true,
                width: 340
              }
            } else {
              json = {
                title: element.label,
                key: element.attr,
                resizable: true,
                tooltip: true,
                ellipsis: true,
                width: (wid - 340 * num) / res.data.length,
              }
            }
          }
          this.columns.push(json)
          if (element.attr.indexOf('Time') == -1 && element.attr.indexOf('FileDescription') == -1 && element.attr.indexOf('version') == -1 && element.attr.indexOf('Version') == -1 && element.attr != 'pid' && element.attr.indexOf('netAct') == -1 && element.attr != 'actionTypeStr' && element.attr != 'logTypeStr' && element.attr != 'netProtocol' && element.attr.indexOf('Index') == -1 && element.attr != 'netProtocol' && element.attr != 'url') {
            this.searchList.push(json2)
          }
          if (this.searchList && this.searchList.length) {
            this.searchType = this.searchList[0].value
          }
        })
      }
    },
    pageSizeChange (val) {
      this.size = val
      if (this.type == 100000) {
        this.exeRunLog()
      } else {
        this.getLogList()
      }
    },
    pagechange (val) {
      this.page = val
      if (this.type == 100000) {
        this.exeRunLog()
      } else {
        this.getLogList()
      }
    },
    setHeight () {
      if (this.$refs.bodyCon1 != undefined && this.$refs.bodyCon1 != '' && this.$refs.bodyCon1.clientHeight != undefined) {
        if (this.$refs.searchCon != undefined) {
          this.height = this.$refs.bodyCon1.clientHeight - this.$refs.searchCon.clientHeight - 60
          this.width = this.$refs.bodyCon1.clientWidth
        } else {
          this.height = this.$refs.bodyCon1.clientHeight - 60
          this.width = this.$refs.bodyCon1.clientWidth
        }
      }
    },
    dragFn () {
      let dom = this.$refs.table.$refs.header.getElementsByTagName('th')
      dragTable(this, dom)
    }
  },
}
</script>
<style lang="scss" >
.logCon {
  height: 100%;

  .tableCon {
    .ivu-tooltip .ivu-tooltip-rel {
      width: 100% !important;
    }
  }

  .ivu-table:before,
  .ivu-table-border:after {
    display: none;
  }

  select {
    line-height: 30px;
    border: 1px solid #eee;
    height: 30px;
  }

  .searchCons {
    margin-bottom: 10px;
  }

  .pageCon {
    bottom: 4px;
    right: 0;
    z-index: 999;
  }
}
</style>
<style lang="scss">
// .logCon {
//   // .ivu-tabs-bar {
//   //   border: none;
//   // }
// }

.tableCon {
  // .ivu-table-header thead tr th{
  //   height: 30px !important;
  // }
  .ivu-table td {
    height: 30px !important;
    font-size: 12px;
    line-height: 30px !important;
  }

  .ivu-tabs-content {
    height: calc(100% - 10px) !important;
  }
}
</style>